<template>
    <div class="app-container1">
     <div id="base" class="">

   

      <!-- Unnamed (Rectangle) -->
      <div id="u3701" class="ax_default box_1">
        <div id="u3701_div" class=""></div>
        <div id="u3701_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3702" class="ax_default box_1">
        <div id="u3702_div" class=""></div>
        <div id="u3702_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Group) -->
      <div id="u3703" class="ax_default" data-left="275" data-top="220" data-width="530" data-height="134">

        <!-- Unnamed (Rectangle) -->
        <div id="u3704" class="ax_default box_1">
          <div id="u3704_div" class=""></div>
           <div id="u37042" class="innerbox" >
             <!-- for循环展示区域详情信息 -->
           
<table style="border-collapse:collapse;border-spacing: 0;" cellspacing="0" cellpadding="0">

<template v-for="item in quotaLevel2VO.arealist">

  <tr style="height:18px"> 
      <td align="left" width="170"><span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;{{item.area}}</span></td>   
      <td align="left" width="70"><span style="font-size:14px;">节能目标</span></td>     
      <td align="left" width="70"><span style="font-size:14px;">{{item.actural}}元</span></td>  
       <td align="left" width="70"><span style="font-size:14px;">实际节能</span></td>     
      <td align="left" width="70"><span style="font-size:14px;">{{item.savingrate}}元</span></td> 
    
  </tr>
 
  <tr style="height:18px">  
    <td colspan="3"></td>
  </tr>
</template>

 </table>


           </div>
        </div>

       

        <!-- Unnamed (Line) -->
        <div id="u3706" class="ax_default line">
          <img id="u3706_img" class="img " src="../../../../../../assets/common/consumption/icon/month/u354.svg"/>
          <div id="u3706_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3707" class="ax_default label">
          <div id="u3707_div" class=""></div>
          <div id="u3707_text" class="text ">
            <p><span>区域年度节能目标</span></p>
          </div>
        </div>

       

       

      

      </div>

      <!-- Unnamed (Group) -->
      <div id="u3717" class="ax_default" data-left="572" data-top="179" data-width="290" data-height="22">

        <!-- Unnamed (Rectangle) -->
        <div id="u3718" class="ax_default label">
          <div id="u3718_div" class=""></div>
          <div id="u3718_text" class="text ">
            <p><span></span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3719" class="ax_default label">
          <div id="u3719_div" class=""></div>
          <div id="u3719_text" class="text ">
            <p><span>实际节能量</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3720" class="ax_default label">
          <div id="u3720_div" class=""></div>
          <div id="u3720_text" class="text ">
            <p><span>总目标</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3721" class="ax_default label">
          <div id="u3721_div" class=""></div>
          <div id="u3721_text" class="text ">
            <p><span></span></p>
          </div>
        </div>
      </div>

    

      <!-- Unnamed (Group) -->
      <div id="u3723" class="ax_default" data-left="845" data-top="219" data-width="532" data-height="134">

        <!-- Unnamed (Rectangle) -->
        <div id="u3724" class="ax_default box_1">
          <div id="u3724_div" class=""></div>
           <div id="u37042" class="innerbox" >
             <!-- for循环展示区域详情信息 -->
           
            <table style="border-collapse:collapse;border-spacing: 0;" cellspacing="0" cellpadding="0">

            <template v-for="item in quotaLevel2VO.arealist">

              <tr style="height:18px"> 
                  <td align="left" width="180"><span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;{{item.area}}</span></td>   
                  <td align="left" width="80"><span style="font-size:14px;">节能目标</span></td>     
                  <td align="left" width="80"><span style="font-size:14px;">{{item.forecast}}元</span></td>  
              
                
              </tr>
            
              <tr style="height:18px">  
                <td colspan="3"></td>
              </tr>
            </template>

            </table>


           </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3725" class="ax_default label">
          <div id="u3725_div" class=""></div>
          <div id="u3725_text" class="text ">
            <p><span>区域下一年度节能目标预测</span></p>
          </div>
        </div>

        <!-- Unnamed (Line) -->
        <div id="u3726" class="ax_default line">
          <img id="u3726_img" class="img " src="../../../../../../assets/common/consumption/icon/month/u354.svg"/>
          <div id="u3726_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

      
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3735" class="ax_default button" @click="routerurl(1)">
        <div id="u3735_div" class=""></div>
        <div id="u3735_text" class="text ">
          <p><span>用电</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3736" class="ax_default button" @click="routerurl(2)">
        <div id="u3736_div" class=""></div>
        <div id="u3736_text" class="text ">
          <p><span>用水</span></p>
        </div>
      </div>

      <!-- Unnamed (Line) -->
      <div id="u3737" class="ax_default line">
        <img id="u3737_img" class="img " src="../../../../../../assets/common/consumption/icon/month/u336.svg"/>
        <div id="u3737_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3738" class="ax_default button" @click="routerurl(3)">
        <div id="u3738_div" class=""></div>
        <div id="u3738_text" class="text ">
          <p><span>用气</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3739" class="ax_default button" @click="routerurl(4)">
        <div id="u3739_div" class=""></div>
        <div id="u3739_text" class="text ">
          <p><span>用热</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3740" class="ax_default button" @click="routerurl(5)">
        <div id="u3740_div" class=""></div>
        <div id="u3740_text" class="text ">
          <p><span>其他能源</span></p>
        </div>
      </div>

      <!-- Unnamed (Group) -->
      <div id="u3741" class="ax_default" data-left="257" data-top="396" data-width="1152" data-height="285">

        <!-- Unnamed (Rectangle) -->
        <div id="u3742" class="ax_default label">
          <div id="u3742_div" class=""></div>
          <div id="u3742_text" class="text ">
            <p><span>节能详情</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3743" class="ax_default box_1">
          <div id="u3743_div" class=""></div>
          <div id="u3743_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3744" class="ax_default label">
          <div id="u3744_div" class=""></div>
          <div id="u3744_text" class="text ">
            <p><span>项目</span></p>
          </div>
        </div>

        <!-- Unnamed (Droplist) -->
        <div id="u3745" class="ax_default droplist">
          <div id="u3745_div" class=""></div>
          <el-select  @change="changeProject" clearable v-model="queryParams.projectId"  placeholder="选择项目">
                                            <el-option
                                                    v-for="item in projectList"
                                                    :label="item.projectName"
                                                    :value="item.projectId"
                                                    :key="item.projectId">
                                            </el-option>
                    </el-select>
        </div>
<!-- Unnamed (Rectangle) -->
        <div id="u35442" class="ax_default label">
          <div id="u35442_div" class=""></div>
          <div id="u35442_text" class="text ">
            <p><span>区域</span></p>
          </div>
        </div>

        <!-- Unnamed (Droplist) -->
        <div id="u35452" class="ax_default droplist">
          <tree-select
                                    v-model="queryParams.positionId"
                                    @select="selectPosition"
                                    :disable-branch-nodes="false"
                                    :multiple="false"
                                    :show-count="true"
                                    :flat="true"
                               
                                    :autoFocus="true"
                                    :placeholder="$t('commons.selectPlease')"
                                    :options="positionList" />
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3746" class="ax_default label">
          <div id="u3746_div" class=""></div>
          <div id="u3746_text" class="text ">
            <p><span>周期</span></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u3747" class="ax_default image">
         <el-date-picker
              :default-time="['00:00:00','23:59:59']"
              type="monthrange"
              range-separator=":"
              size="small"
              class="date-item"
              format="yyyy-MM"
              value-format="yyyy-MM-dd HH:mm:ss"
               v-model="pickerOpts.pickerData"
                  :picker-options="pickerOpts"
                   @change="setDateRange"
              start-placeholder="起始时间"
              end-placeholder="截止时间"
            />
             <div id="u3747_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3748" class="ax_default primary_button" @click="handleQuery"> 
          <div id="u3748_div" class=""></div>
          <div id="u3748_text" class="text ">
            <p><span>查询</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3749" class="ax_default box_1">
           <div class="innerbox"  style="width: 100%; height:350px;position: absolute;
z-index: 99;">
                <el-table  :data="consumptionlist"  v-loading="loading"
                style="width: 100%;"
                 show-header="false"
                >
         
                <el-table-column label="时间" align="center" prop="energyMonth" />
                <el-table-column label="区域" align="center" prop="area" />
         
                <el-table-column label="节能目标" align="center" prop="goal" />
                 <el-table-column label="实际节能" align="center" prop="savingrate" />
               
             </el-table>
            
                <pagination v-show="total>0" 
                  :total="total" 
                  :page.sync="queryParams.pageNum"
                  :limit.sync="queryParams.pageSize"
                  @pagination="getList"/>
             </div>
        </div>

      


        <!-- Unnamed (Rectangle) -->
        <div id="u3753" class="ax_default primary_button">
          <div id="u3753_div" class=""></div>
          <div id="u3753_text" class="text ">
            <p><span>导出</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3754" class="ax_default label">
          <div id="u3754_div" class=""></div>
          <div id="u3754_text" class="text ">
            <p><span>暂无数据</span></p>
          </div>
        </div>

      
      </div>

    </div>
    </div>
    
 

</template>
<script>
import "echarts/theme/macarons";
import {
  getLevel1,//总汇总
  listLevel1,//总查询列表
  getPowerLevel2,//电
  listPower,//电
  getWaterLevel2,//水
  listWater,// 水
  getGasLevel2,//气
  listGas,//气
  getHotLevel2,//热
  listHot,//热
  getOthersLevel2,//其他
  listOthers,//其他
} from "@/api/business/energy/performanc";
import {
  getPerformancLevel1,//总汇总

} from "@/api/business/energy/performanc";

import{
        getProjectList
    }from '@/api/business/base/tenant/project';
    import {      
        getPositionTree
    } from '@/api/business/base/tenant/device';
     import {listToTree} from '@/utils/tree';
    import TreeSelect from '@riophae/vue-treeselect';   
        import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import Pagination from '@/components/Pagination';
export default {
  name: "energyOverview",
     components: {Pagination,TreeSelect},
  data() {
    return {
          // 遮罩层
      loading: false,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 岗位表格数据
      quotaList: [],
        projectList:[],
           positionList:[],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 状态数据字典
      statusOptions: [],
       queryParams: {
                   pageNum: 1,
                   pageSize: 10,
                   area: null,
              
                   childEnergyType: null,
                     areaid: null,
                 positionId : null,
                   projectId: null,
                   startTime: null,
                   endTime: null
               },
               // 日期范围查询组件
               pickerOpts: {
                   // 默认日期
                   pickerData: null,
                   // 快捷选项
                   shortcuts: null,
               },
      energyTypeList: [
        { itemCode: 1, itemName: "空调用电" },
        { itemCode: 2, itemName: "照明用电" },
        { itemCode: 3, itemName: "东力用电" },
        { itemCode: 4, itemName: "特殊用电" },
      ],
      areaTypeList: [
        { itemCode: 1, itemName: "一区" },
        { itemCode: 2, itemName: "二区" },
        { itemCode: 3, itemName: "三区" },
        { itemCode: 4, itemName: "四区" },
      ],
      buildingTypeList: [
        { itemCode: 1, itemName: "1号楼" },
        { itemCode: 2, itemName: "2号楼" },
        { itemCode: 3, itemName: "3号楼" },
        { itemCode: 4, itemName: "4号楼" },
      ],
      unitTypeList: [
        { itemCode: 1, itemName: "1单元" },
        { itemCode: 2, itemName: "2单元" },
        { itemCode: 3, itemName: "3单元" },
        { itemCode: 4, itemName: "4单元" },
      ],
     
     
          yearlyProportionOptionsArea: null,
          yearlyProportionOptionsType: null,
             //接收总统计数据的对象
        quotaLevel2VO: {
          arealist: [],
          airconditionactural: "",
          airconditionforeast: "",
          airconditionsavingrate: "",

          lightactural: "",
          lightforeast: "",
          lightsavingrate: "",

          poweractural: "",
          powerforeast: "",
           lightsavingrate: "",

          specialractural: "",
          specialforeast: "",
          lightsavingrate: "",

          wateractural: "",
          waterforeast: "",

          gasactural: "",
          gasforeast: "",

          hotactural: "",
          hotforeast: "",

          othersactural: "",
          othersforeast: "",

          tapwateractural: "",
          tapwaterforecast: "",

          reclaimedwateractural: "",
          reclaimedwaterforecast: "",
        },
             performancLevel1VO: {
        //----------汇总年数据-------------
    //今年总节能目标
    powerYear: "",//1
    waterYear: "",//2
    gasYear: "",//3
    hotYear: "",//4
    othersYear: "",//5
    totalYear: "",//0
    goal: "",
    savingrate: "",
    //---今年总节能完成度评价
    powerCompletionYear: "",
    waterCompletionYear: "",
    gasCompletionYear: "",
    hotCompletionYear: "",
    othersCompletionYear: "",
    totalCompletionYear: "",

    //---今年实际完成率
    powerSavingRateYear: "",
    waterSavingRateYear: "",
    gasSavingRateYear: "",
    hotSavingRateYear: "",
    otherschangeRateYear: "",
    totalSavingRateYear: "",

    //--下一周期预测
    powerForecastYear: "",
    waterForecastYear: "",
    gasForecastYear: "",
    hotForecastYear: "",
    othersForecastYear: "",
    totalForecastYear: "",
    //----------------汇总季-----------------------------
    //电
    totalSeason1: "",
    totalSeason2: "",
    totalSeason3: "",
    totalSeason4: "",


    //---季度节能完成度评价
    totalCompletionSeason1: "",
    totalCompletionSeason2: "",
    totalCompletionSeason3: "",
    totalCompletionSeason4: "",

    //---季用完成率
    totalSavingRateSeason1: "",
    totalSavingRateSeason2: "",
    totalSavingRateSeason3: "",
    totalSavingRateSeason4: "",

    //--季下一周期预测
    totalForecastSeason1: "",
    totalForecastSeason2: "",
    totalForecastSeason3: "",
    totalForecastSeason4: "",

    //----------------电-----------------------------
    //电季
    powerSeason1: "",
    powerSeason2: "",
    powerSeason3: "",
    powerSeason4: "",


    //---季度节能完成度评价
    powerCompletionSeason1: "",
    powerCompletionSeason2: "",
    powerCompletionSeason3: "",
    powerCompletionSeason4: "",

    //---季用节能率
    powerSavingRateSeason1: "",
    powerSavingRateSeason2: "",
    powerSavingRateSeason3: "",
    powerSavingRateSeason4: "",

    //--季下一周期预测
    powerForecastSeason1: "",
    powerForecastSeason2: "",
    powerForecastSeason3: "",
    powerForecastSeason4: "",


    //---------------水----------------------------------------

    //水季
    waterSeason1: "",
    waterSeason2: "",
    waterSeason3: "",
    waterSeason4: "",
    //---季度节能完成度评价
    waterCompletionSeason1: "",
    waterCompletionSeason2: "",
    waterCompletionSeason3: "",
    waterCompletionSeason4: "",

    //---季节能完成率
    waterSavingRateSeason1: "",
    waterSavingRateSeason2: "",
    waterSavingRateSeason3: "",
    waterSavingRateSeason4: "",

    //--水季下一周期预测
    waterForecastSeason1: "",
    waterForecastSeason2: "",
    waterForecastSeason3: "",
    waterForecastSeason4: "",

    //--------------气--------------------------------------
    //气
    gasSeason1: "",
    gasSeason2: "",
    gasSeason3: "",
    gasSeason4: "",
    //---季度节能完成度评价
    gasCompletionSeason1: "",
    gasCompletionSeason2: "",
    gasCompletionSeason3: "",
    gasCompletionSeason4: "",
    //---季节能完成率
    gasSavingRateSeason1: "",
    gasSavingRateSeason2: "",
    gasSavingRateSeason3: "",
    gasSavingRateSeason4: "",

    //--气下一周期预测
    gasForecastSeason1: "",
    gasForecastSeason2: "",
    gasForecastSeason3: "",
    gasForecastSeason4: "",

    //--------------热-----------------------------
    //热
    hotSeason1: "",
    hotSeason2: "",
    hotSeason3: "",
    hotSeason4: "",
    //---季度节能完成度评价
    hotCompletionSeason1: "",
    hotCompletionSeason2: "",
    hotCompletionSeason3: "",
    hotCompletionSeason4: "",
    //---季节能完成率
    hotSavingRateSeason1: "",
    hotSavingRateSeason2: "",
    hotSavingRateSeason3: "",
    hotSavingRateSeason4: "",

    //--热季下一周期预测
    hotForecastSeason1: "",
    hotForecastSeason2: "",
    hotForecastSeason3: "",
    hotForecastSeason4: "",
    //----------------其他-----------------------------
    //其他
    othersSeason1: "",
    othersSeason2: "",
    othersSeason3: "",
    othersSeason4: "",


    //---季度节能完成度评价
    othersCompletionSeason1: "",
    othersCompletionSeason2: "",
    othersCompletionSeason3: "",
    othersCompletionSeason4: "",

    //---季节能完成率
    othersSavingRateSeason1: "",
    othersSavingRateSeason2: "",
    othersSavingRateSeason3: "",
    othersSavingRateSeason4: "",

    //--季下一周期预测
    othersForecastSeason1: "",
    othersForecastSeason2: "",
    othersForecastSeason3: "",
    othersForecastSeason4: "",
    //---------------总节能月----
    //总节能
    totalMonth1: "",
    totalMonth2: "",
    totalMonth3: "",
    totalMonth4: "",
    totalMonth5: "",
    totalMonth6: "",
    totalMonth7: "",
    totalMonth8: "",
    totalMonth9: "",
    totalMonth10: "",
    totalMonth11: "",
    totalMonth12: "",

    //总节能完成度评价
    totalCompletionMonth1: "",
    totalCompletionMonth2: "",
    totalCompletionMonth3: "",
    totalCompletionMonth4: "",
    totalCompletionMonth5: "",
    totalCompletionMonth6: "",
    totalCompletionMonth7: "",
    totalCompletionMonth8: "",
    totalCompletionMonth9: "",
    totalCompletionMonth10: "",
    totalCompletionMonth11: "",
    totalCompletionMonth12: "",
    //---总节能完成率
    totalSavingRateMonth1: "",
    totalSavingRateMonth2: "",
    totalSavingRateMonth3: "",
    totalSavingRateMonth4: "",
    totalSavingRateMonth5: "",
    totalSavingRateMonth6: "",
    totalSavingRateMonth7: "",
    totalSavingRateMonth8: "",
    totalSavingRateMonth9: "",
    totalSavingRateMonth10: "",
    totalSavingRateMonth11: "",
    totalSavingRateMonth12: "",


    //--总下一周期预测
    totalForecastMonth1: "",
    totalForecastMonth2: "",
    totalForecastMonth3: "",
    totalForecastMonth4: "",
    totalForecastMonth5: "",
    totalForecastMonth6: "",
    totalForecastMonth7: "",
    totalForecastMonth8: "",
    totalForecastMonth9: "",
    totalForecastMonth10: "",
    totalForecastMonth11: "",
    totalForecastMonth12: "",

    //-------------电月----------------------------
    //电
    powerMonth1: "",
    powerMonth2: "",
    powerMonth3: "",
    powerMonth4: "",
    powerMonth5: "",
    powerMonth6: "",
    powerMonth7: "",
    powerMonth8: "",
    powerMonth9: "",
    powerMonth10: "",
    powerMonth11: "",
    powerMonth12: "",

    //电节能完成度评价
    powerCompletionMonth1: "",
    powerCompletionMonth2: "",
    powerCompletionMonth3: "",
    powerCompletionMonth4: "",
    powerCompletionMonth5: "",
    powerCompletionMonth6: "",
    powerCompletionMonth7: "",
    powerCompletionMonth8: "",
    powerCompletionMonth9: "",
    powerCompletionMonth10: "",
    powerCompletionMonth11: "",
    powerCompletionMonth12: "",
    //---月节能完成率
    powerSavingRateMonth1: "",
    powerSavingRateMonth2: "",
    powerSavingRateMonth3: "",
    powerSavingRateMonth4: "",
    powerSavingRateMonth5: "",
    powerSavingRateMonth6: "",
    powerSavingRateMonth7: "",
    powerSavingRateMonth8: "",
    powerSavingRateMonth9: "",
    powerSavingRateMonth10: "",
    powerSavingRateMonth11: "",
    powerSavingRateMonth12: "",


    //--月下一周期预测
    powerForecastMonth1: "",
    powerForecastMonth2: "",
    powerForecastMonth3: "",
    powerForecastMonth4: "",
    powerForecastMonth5: "",
    powerForecastMonth6: "",
    powerForecastMonth7: "",
    powerForecastMonth8: "",
    powerForecastMonth9: "",
    powerForecastMonth10: "",
    powerForecastMonth11: "",
    powerForecastMonth12: "",
    //--------------------
    //--------------------------水----------------------------
    waterMonth1: "",
    waterMonth2: "",
    waterMonth3: "",
    waterMonth4: "",
    waterMonth5: "",
    waterMonth6: "",
    waterMonth7: "",
    waterMonth8: "",
    waterMonth9: "",
    waterMonth10: "",
    waterMonth11: "",
    waterMonth12: "",
    //水节能完成度评价
    waterCompletionMonth1: "",
    waterCompletionMonth2: "",
    waterCompletionMonth3: "",
    waterCompletionMonth4: "",
    waterCompletionMonth5: "",
    waterCompletionMonth6: "",
    waterCompletionMonth7: "",
    waterCompletionMonth8: "",
    waterCompletionMonth9: "",
    waterCompletionMonth10: "",
    waterCompletionMonth11: "",
    waterCompletionMonth12: "",
    //---月节能完成率
    waterSavingRateMonth1: "",
    waterSavingRateMonth2: "",
    waterSavingRateMonth3: "",
    waterSavingRateMonth4: "",
    waterSavingRateMonth5: "",
    waterSavingRateMonth6: "",
    waterSavingRateMonth7: "",
    waterSavingRateMonth8: "",
    waterSavingRateMonth9: "",
    waterSavingRateMonth10: "",
    waterSavingRateMonth11: "",
    waterSavingRateMonth12: "",

    //--月下一周期预测
    waterForecastMonth1: "",
    waterForecastMonth2: "",
    waterForecastMonth3: "",
    waterForecastMonth4: "",
    waterForecastMonth5: "",
    waterForecastMonth6: "",
    waterForecastMonth7: "",
    waterForecastMonth8: "",
    waterForecastMonth9: "",
    waterForecastMonth10: "",
    waterForecastMonth11: "",
    waterForecastMonth12: "",
    //-------------------------气------------------------
    gasMonth1: "",
    gasMonth2: "",
    gasMonth3: "",
    gasMonth4: "",
    gasMonth5: "",
    gasMonth6: "",
    gasMonth7: "",
    gasMonth8: "",
    gasMonth9: "",
    gasMonth10: "",
    gasMonth11: "",
    gasMonth12: "",
    //气节能完成度评价
    gasCompletionMonth1: "",
    gasCompletionMonth2: "",
    gasCompletionMonth3: "",
    gasCompletionMonth4: "",
    gasCompletionMonth5: "",
    gasCompletionMonth6: "",
    gasCompletionMonth7: "",
    gasCompletionMonth8: "",
    gasCompletionMonth9: "",
    gasCompletionMonth10: "",
    gasCompletionMonth11: "",
    gasCompletionMonth12: "",
    //---月节能完成率
    gasSavingRateMonth1: "",
    gasSavingRateMonth2: "",
    gasSavingRateMonth3: "",
    gasSavingRateMonth4: "",
    gasSavingRateMonth5: "",
    gasSavingRateMonth6: "",
    gasSavingRateMonth7: "",
    gasSavingRateMonth8: "",
    gasSavingRateMonth9: "",
    gasSavingRateMonth10: "",
    gasSavingRateMonth11: "",
    gasSavingRateMonth12: "",

    //--月下一周期预测
    gasForecastMonth1: "",
    gasForecastMonth2: "",
    gasForecastMonth3: "",
    gasForecastMonth4: "",
    gasForecastMonth5: "",
    gasForecastMonth6: "",
    gasForecastMonth7: "",
    gasForecastMonth8: "",
    gasForecastMonth9: "",
    gasForecastMonth10: "",
    gasForecastMonth11: "",
    gasForecastMonth12: "",

    //--------------------热-------------------------------
    hotMonth1: "",
    hotMonth2: "",
    hotMonth3: "",
    hotMonth4: "",
    hotMonth5: "",
    hotMonth6: "",
    hotMonth7: "",
    hotMonth8: "",
    hotMonth9: "",
    hotMonth10: "",
    hotMonth11: "",
    hotMonth12: "",
    //热节能完成度评价
    hotCompletionMonth1: "",
    hotCompletionMonth2: "",
    hotCompletionMonth3: "",
    hotCompletionMonth4: "",
    hotCompletionMonth5: "",
    hotCompletionMonth6: "",
    hotCompletionMonth7: "",
    hotCompletionMonth8: "",
    hotCompletionMonth9: "",
    hotCompletionMonth10: "",
    hotCompletionMonth11: "",
    hotCompletionMonth12: "",
    //---月节能完成率
    hotSavingRateMonth1: "",
    hotSavingRateMonth2: "",
    hotSavingRateMonth3: "",
    hotSavingRateMonth4: "",
    hotSavingRateMonth5: "",
    hotSavingRateMonth6: "",
    hotSavingRateMonth7: "",
    hotSavingRateMonth8: "",
    hotSavingRateMonth9: "",
    hotSavingRateMonth10: "",
    hotSavingRateMonth11: "",
    hotSavingRateMonth12: "",


    //--月下一周期预测
    hotForecastMonth1: "",
    hotForecastMonth2: "",
    hotForecastMonth3: "",
    hotForecastMonth4: "",
    hotForecastMonth5: "",
    hotForecastMonth6: "",
    hotForecastMonth7: "",
    hotForecastMonth8: "",
    hotForecastMonth9: "",
    hotForecastMonth10: "",
    hotForecastMonth11: "",
    hotForecastMonth12: "",
    //--------------------------------------其他----

    othersMonth1: "",
    othersMonth2: "",
    othersMonth3: "",
    othersMonth4: "",
    othersMonth5: "",
    othersMonth6: "",
    othersMonth7: "",
    othersMonth8: "",
    othersMonth9: "",
    othersMonth10: "",
    othersMonth11: "",
    othersMonth12: "",

    //其他节能完成度评价
    othersCompletionMonth1: "",
    othersCompletionMonth2: "",
    othersCompletionMonth3: "",
    othersCompletionMonth4: "",
    othersCompletionMonth5: "",
    othersCompletionMonth6: "",
    othersCompletionMonth7: "",
    othersCompletionMonth8: "",
    othersCompletionMonth9: "",
    othersCompletionMonth10: "",
    othersCompletionMonth11: "",
    othersCompletionMonth12: "",
    //---其他节能完成率
    othersSavingRateMonth1: "",
    othersSavingRateMonth2: "",
    othersSavingRateMonth3: "",
    othersSavingRateMonth4: "",
    othersSavingRateMonth5: "",
    othersSavingRateMonth6: "",
    othersSavingRateMonth7: "",
    othersSavingRateMonth8: "",
    othersSavingRateMonth9: "",
    othersSavingRateMonth10: "",
    othersSavingRateMonth11: "",
    othersSavingRateMonth12: "",


    //--其他下一周期预测
    othersForecastMonth1: "",
    othersForecastMonth2: "",
    othersForecastMonth3: "",
    othersForecastMonth4: "",
    othersForecastMonth5: "",
    othersForecastMonth6: "",
    othersForecastMonth7: "",
    othersForecastMonth8: "",
    othersForecastMonth9: "",
    othersForecastMonth10: "",
    othersForecastMonth11: "",
    othersForecastMonth12: "",
      }
      
    };
  },
  created() {
     getHotLevel2(this.queryParams).then((response) => {
        
          this.quotaLevel2VO = response.data;
          
         //this.yearlyProportionOptionsArea=this.yearlyProportionArea();
         // this.yearlyProportionOptionsType=this.yearlyProportionType();
      });
       getPerformancLevel1(this.queryParams).then((response) => {
          // alert("11111");
          this.performancLevel1VO = response.data;
         // alert(this.performancLevel1VO.arealist.length);
       });
        this.getProjectList(141);
  },
   methods: {
      // 设置日期范围查询条件
     setFlag1(iflag) {
        // alert("child="+iflag);
        //   this.flag=iflag;
        this.$emit("changeFlag",iflag);
       //  alert("child="+iflag);

     },
        //----------------位置选择----------------------------
             selectPosition(node){
                this.queryParams.positionId = node.positionId;
                //alert(this.listQuery.positionId);
               },
                
           
            getProjectList(companyId){
             // alert(companyId);
                getProjectList({"companyId":companyId}).then(res=>{
                    this.projectList = res;
                    //alert(this.projectList.length);
                })
                
            },
           changeProject() {
                // alert(this.queryParams.projectId);
                if(this.queryParams.projectId == ''){
                    this.queryParams.projectId = null;
                    this.queryParams.positionId = null;
                    this.positionList = [];
                }else{                   
                   getPositionTree({"projectId":this.queryParams.projectId}).then(response =>{
                     
                      // alert(this.queryParams.projectId);
                        this.queryParams.positionId = null;
                        this.positionList = [];
                        let data = listToTree(response,"positionId","parentId");
                        this.recursivePosition(data)
                    });
                }
            },
            //递归位置列表修改属性及数据结构
            recursivePosition(row){
                let data = row.map(v => {
                    v.label = v.positionName;
                    v.id = v.positionId;
                    if(v.children != undefined){
                        this.recursivePosition(v.children);
                    }
                    return v
                })
                //alert(this.queryParams.projectId);
                this.positionList = data;
            },
          
           

    //----------------------------------------------   
            /** 搜索按钮操作 */
    handleQuery() {
     
      this.queryParams.pageNum = 1;
      this.getList();
    },
       /** 查询列表 */
    getList() {
      this.loading = true;
   
      listHot(this.queryParams).then((response) => {
    
      
        this.consumptionlist = response.rows;
         // alert(thi for(var i=0;i<response.rows.length;i++){
         for(var i=0;i<response.rows.length;i++){
        
           
               response.rows[i].energyMonth=response.rows[i].energyYear+'-'+response.rows[i].energyMonth;
           
              
        }
        this.total = response.total;
        this.loading = false;
      });
    },
        setDateRange(dateRange) {
        
          //alert(dateRange[0].substr(0,7));
        
         if (dateRange) {
                    this.queryParams.startTime = dateRange[0].substr(0,7);
                    this.queryParams.endTime = dateRange[1].substr(0,7);
                    
          } else {// 清空
                    this.queryParams.startTime = null;
                    this.queryParams.endTime = null;
           }
               
         },
                           routerurl(flag){
         switch(flag){
           case 1:
              this.$router.push('/performanc/level2/power/index');
             break;
           case 2:
              this.$router.push('/performanc/level2/water/index');
              break;
             
           case 3:
              this.$router.push('/performanc/level2/gas/index');
             break;
           case 4:
              this.$router.push('/performanc/level2/hot/index');
             break;
          case 5:
              this.$router.push('/performanc/level2/others/index');
             break;   
         }
     },
   }
}
</script>
<style scoped src="../../../../../../assets/common/performanc/css/hot/styles.css"></style>
<style scoped>
   @import "../../../../../../assets/common/consumption/css/styles.css";
   @import "../../../../../../assets/common/rp_page.css";
   .app-container1 {
  padding: 10px;
  
  background-color: rgba(243, 247, 255, 1);
  border-radius: 5px;
  min-height: calc(100vh + 900px);
  
}
</style>
